import { useEffect } from 'react';
import { registerAccessTokenProvider } from '../api/authToken';
import { useAuth } from './useAuth';

/**
 * Registers the active session's token getter with the Axios API clients once the
 * user is authenticated. Google sessions supply the API-issued access token;
 * Entra sessions continue to use MSAL silent acquisition.
 * Renders nothing; mount it inside `AuthProvider`.
 */
export const AuthTokenBridge: React.FC = () => {
  const { isAuthenticated, acquireToken } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      registerAccessTokenProvider(acquireToken);
    } else {
      registerAccessTokenProvider(null);
    }
    return () => registerAccessTokenProvider(null);
  }, [isAuthenticated, acquireToken]);

  return null;
};
